import { bootstrapApplication } from '@angular/platform-browser'
import * as Sentry from '@sentry/angular'
import { App } from './app/app'
import { appConfig } from './app/app.config'
import { environment } from './app/load.env'

if (environment.ENVIRONMENT !== 'local') {
    Sentry.init({
        dsn: environment.SENTRY_DNS,
        sendDefaultPii: environment.SENTRY_SEND_DEFAULT_PII,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: environment.SENTRY_MASK_ALL_TEXT,
                blockAllMedia: environment.SENTRY_MASK_ALL_INPUT
            })
        ],
        tracesSampleRate: environment.SENTRY_TRACE_SAMPLE_RATE,
        replaysSessionSampleRate: environment.SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
        replaysOnErrorSampleRate: environment.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
        environment: environment.ENVIRONMENT
    })
}

bootstrapApplication(App, appConfig).catch((err) => {
    console.error(err)
})
